import { Button, ButtonGroup } from "@chakra-ui/react";

const VIEW_LABELS = { mes: "Mês", semana: "Semana", lista: "Lista" };

// Alternador segmentado das visões do Calendário.
export default function CalendarViewSwitcher({ view, onChange }) {
  return (
    <ButtonGroup size="sm" isAttached variant="outline" role="group" aria-label="Visão do calendário">
      {Object.entries(VIEW_LABELS).map(([key, label]) => (
        <Button key={key} variant={view === key ? "solid" : "outline"} aria-pressed={view === key} onClick={() => onChange(key)}>
          {label}
        </Button>
      ))}
    </ButtonGroup>
  );
}
